import AppRoute from "models/AppRoute"
import { Guid } from "@/types"

interface IOutgoingInvoiceDraftByDateRouteParams {
    reservationId: Guid
    start: string
    end: string
}

const OutgoingInvoiceDraftByDateRoute = new AppRoute<IOutgoingInvoiceDraftByDateRouteParams, {}>({
    route: "/outgoing-invoice/:reservationId/draft/:start/:end",
    navbar: true,
    authRequired: true,
})

export default OutgoingInvoiceDraftByDateRoute
